import { redirectUrl } from "constant/redirectUrl";

export const handleClick = () => {
  window.open(redirectUrl, "_blank");
};
